  (function () {
    if (!window.__bhReveal) {
      window.__bhReveal = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var run = function () {
        var els = document.querySelectorAll('.bh-reveal, .bh-settle');
        if (reduce.matches || !('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) els[i].classList.add('is-in'); return; }
        document.documentElement.classList.add('bh-motion');
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        els.forEach(function (el) { io.observe(el); });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    }
  })();

  // Monthly configurator — live shipment label + add the matched Standing Arrangement variant.
  // Subscription is created natively: the chosen cadence is matched to one of the variant's
  // Appstle selling plans (by delivery interval) and posted as selling_plan to /cart/add.js.
  (function () {
    var root = document.querySelector('[data-configurator]');
    if (!root) return;
    function activeIn(group) { return root.querySelector('[data-group="' + group + '"] .bh-opt-pill.active'); }
    var out = {
      selection: root.querySelector('[data-out="selection"]'),
      size: root.querySelector('[data-out="size"]'),
      cadence: root.querySelector('[data-out="cadence"]'),
      amount: root.querySelector('[data-out="amount"]'),
      cadenceTail: root.querySelector('[data-out="cadence-tail"]')
    };
    var addBtn = root.querySelector('[data-add]');
    var addedNote = root.querySelector('[data-added]');
    var addedNoteText = addedNote ? addedNote.textContent : '';

    function select(group, pill) {
      root.querySelectorAll('[data-group="' + group + '"] .bh-opt-pill').forEach(function (p) { p.classList.toggle('active', p === pill); });
      render();
    }
    function render() {
      var sel = activeIn('selection'), size = activeIn('size'), cadence = activeIn('cadence');
      if (out.selection && sel) out.selection.textContent = sel.getAttribute('data-label') || sel.getAttribute('data-value');
      if (out.size && size) out.size.textContent = size.getAttribute('data-label') || size.getAttribute('data-value');
      if (out.cadence && cadence) out.cadence.textContent = cadence.getAttribute('data-label') || cadence.getAttribute('data-value');
      if (out.amount && sel && size) {
        var coffee = sel.getAttribute('data-value'), boxes = size.getAttribute('data-value');
        var mv = (window.__blaqSubVariants || []).filter(function (v) { return v.c === coffee && v.b === boxes; })[0];
        if (mv && mv.price != null) {
          out.amount.textContent = mv.price;
        } else {
          var unit = parseInt(sel.getAttribute('data-price'), 10) || 0;
          var qty = parseInt(size.getAttribute('data-qty'), 10) || 1;
          out.amount.textContent = unit * qty;
        }
      }
      if (out.cadenceTail && cadence) out.cadenceTail.textContent = cadence.getAttribute('data-tail') || '';
    }
    ['selection', 'size', 'cadence'].forEach(function (group) {
      root.querySelectorAll('[data-group="' + group + '"] .bh-opt-pill').forEach(function (pill) {
        pill.addEventListener('click', function () { select(group, pill); });
      });
    });
    render();

    // Choose the selling plan on this variant whose delivery interval matches the
    // chosen cadence. Interval + count are parsed from the plan name (e.g.
    // "Every Month" -> MONTH/1, "Every 2 Weeks" -> WEEK/2), because Shopify storefront
    // Liquid does not expose interval/count fields on selling plans. Fail-closed: if
    // nothing matches the chosen cadence, return null so we never silently subscribe
    // the customer to a different rhythm.
    function planMeta(name) {
      var m = (name || '').toLowerCase().match(/(\d+)?\s*(day|week|month|year)/);
      return m ? { interval: m[2].toUpperCase(), count: parseInt(m[1] || '1', 10) } : null;
    }
    function pickPlanId(variant, cadence) {
      var plans = (variant && variant.plans) || [];
      if (!plans.length) return null;
      if (cadence) {
        var wantInterval = (cadence.getAttribute('data-interval') || '').toUpperCase();
        var wantCount = parseInt(cadence.getAttribute('data-interval-count'), 10);
        for (var i = 0; i < plans.length; i++) {
          var meta = planMeta(plans[i].name);
          if (meta && meta.interval === wantInterval && meta.count === wantCount) return plans[i].id;
        }
      }
      return null; // no plan whose delivery interval matches the chosen cadence
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var sel = activeIn('selection'), size = activeIn('size'), cadence = activeIn('cadence');
        var variants = window.__blaqSubVariants || [];
        var coffee = sel ? sel.getAttribute('data-value') : '';
        var boxes = size ? size.getAttribute('data-value') : '';
        var match = variants.filter(function (v) { return v.c === coffee && v.b === boxes; })[0];
        if (!match) { window.location.href = root.getAttribute('data-sub-url') || '/products/the-standing-arrangement'; return; }
        var planId = pickPlanId(match, cadence);
        // Fail-closed: a cadence was chosen but no plan on this variant matches it.
        // Do not attach a different (e.g. weekly) plan and do not silently add it as a
        // one-time purchase. Block and tell the customer this rhythm is not available yet.
        if (cadence && !planId) {
          if (addedNote) {
            addedNote.textContent = 'This rhythm is not available yet';
            addedNote.classList.add('show');
            clearTimeout(addBtn._t); addBtn._t = setTimeout(function () { addedNote.classList.remove('show'); }, 3600);
          }
          return;
        }
        var props = { 'Cadence': cadence ? (cadence.getAttribute('data-label') || cadence.getAttribute('data-value')) : 'Monthly', 'Lot': "Roaster's choice, single origin" };
        var body = { id: match.id, quantity: 1, properties: props };
        if (planId) body.selling_plan = planId;
        addBtn.disabled = true; addBtn.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
          .then(function () {
            if (addedNote) { addedNote.textContent = addedNoteText; addedNote.classList.add('show'); clearTimeout(addBtn._t); addBtn._t = setTimeout(function () { addedNote.classList.remove('show'); }, 3600); }
            // Refresh the cart view + badge and open the drawer using the theme's real
            // ajax-cart API (z__jsAjaxCart.js). updateView() re-renders the drawer and sets
            // [data-bind="itemCount"] from a fresh cart section fetch; showDrawer() slides it in.
            var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
            if (ajaxCart && typeof ajaxCart.updateView === 'function') { ajaxCart.updateView(); }
            if (ajaxCart && typeof ajaxCart.showDrawer === 'function') { ajaxCart.showDrawer(); }
            // Resilient fallback: if the ajax-cart API is unavailable or its name differs,
            // still set the header badge directly from a fresh /cart.js item_count.
            if (!ajaxCart || typeof ajaxCart.updateView !== 'function') {
              fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (c) {
                  var badges = document.querySelectorAll('[data-bind="itemCount"]');
                  for (var i = 0; i < badges.length; i++) badges[i].textContent = c.item_count;
                })
                .catch(function () {});
            }
          })
          .catch(function (err) { alert((err && err.description) || 'Could not start the subscription. Please try again.'); })
          .finally(function () { addBtn.disabled = false; addBtn.textContent = 'Start the subscription'; });
      });
    }
  })();
